import { useEffect } from 'react';
import { finishEntryLoading } from '@/lib/entryLoading';

/** Mount inside the route's Suspense so the boot cover waits for actual content. */
export default function EntryReady() {
  useEffect(() => {
    void finishEntryLoading();
  }, []);
  return null;
}
